define("PLPBreadCrumbs.View", [
  "SCView",
  "global_views_breadcrumb.tpl",
], function (SCViewComponent, breadcrumb_tpl) {
  "use strict";

  var SCView = SCViewComponent.SCView;

  function PLPBreadCrumbsView(options) {
    try {
      SCView.call(this);
      this.options = options;
      this.template = breadcrumb_tpl;
      this.pages = this.options.breadcrumbs || [];
      this.showBreadcrumbMicrodata = !!this.options.showBreadcrumbMicrodata;
      this.getContext = function () {
        return {
          pages: this.pages,
          showBreadcrumbMicrodata: this.showBreadcrumbMicrodata,
        };
      };
    } catch (error) {
      console.log(error);
    }
  }

  PLPBreadCrumbsView.prototype = Object.create(SCView.prototype);
  PLPBreadCrumbsView.prototype.constructor = PLPBreadCrumbsView;

  return PLPBreadCrumbsView;
});
